import { Routes } from '@angular/router';
import { AuthGuardWithForcedLogin } from '@ortho-next/auth-core';
import { AppVersionGuard } from './app-version.guard';
import { ErrorComponent, FallbackComponent } from './core';
import { DashboardComponent } from './dashboard';
import { HistoryComponent } from './history';
import { ListComponent } from './list';
import { PatientSettingsComponent } from './patient';
import { PlanSettingsComponent } from './plan';
import { PublishComponent, PublishPatientComponent, PublishPlanComponent } from './publish';
import { ContainerTemplateComponent } from './template';


export enum PAGE {
	ERROR = 'error',
	DASHBOARD = 'dashboard',
	PATIENT_LIST = 'list',
	PATIENT_SETTINGS = 'patient/edit',
	PATIENT_HISTORY = 'patient/history',
	PLAN_SETTINGS = 'plan/edit',
	PUBLISH = 'publish',
	PUBLISH_PLAN = '/publish/plan',
	PUBLISH_PATIENT = '/publish/patient'
}

export const routes: Routes = [
	{ path: PAGE.ERROR, component: ErrorComponent },
	{
		path: '', component: ContainerTemplateComponent, children: [
			{ path: '', redirectTo: PAGE.DASHBOARD, pathMatch: 'full' },
			{ path: PAGE.DASHBOARD, component: DashboardComponent, canActivate: [AuthGuardWithForcedLogin] },
			{ path: PAGE.PATIENT_LIST, component: ListComponent, canActivate: [AuthGuardWithForcedLogin] },
			{ path: PAGE.PATIENT_SETTINGS, component: PatientSettingsComponent, canActivate: [AuthGuardWithForcedLogin] },
			{ path: PAGE.PATIENT_HISTORY, component: HistoryComponent, canActivate: [AuthGuardWithForcedLogin] },
			{ path: PAGE.PLAN_SETTINGS, component: PlanSettingsComponent, canActivate: [AuthGuardWithForcedLogin] },
			{
				path: PAGE.PUBLISH, component: PublishComponent, children: [
					{ path: '', redirectTo: 'plan', pathMatch: 'full' },
					{ path: 'plan', component: PublishPlanComponent, canActivate: [AuthGuardWithForcedLogin] },
					{ path: 'patient', component: PublishPatientComponent, canActivate: [AuthGuardWithForcedLogin] }
				], canActivate: [AuthGuardWithForcedLogin]
			}
		], canActivate: [AuthGuardWithForcedLogin, AppVersionGuard]
	},
	{ path: '**', component: FallbackComponent, canActivate: [AuthGuardWithForcedLogin] }
];
